'use client'
import { useEffect, useState } from 'react'
import { useCurrency } from '@/lib/currency'

function timeAgo(iso) {
  if (!iso) return null
  const mins = Math.round((Date.now() - new Date(iso).getTime()) / 60000)
  if (mins < 1) return 'just now'
  if (mins < 60) return `${mins} min ago`
  const hrs = Math.floor(mins / 60)
  return `${hrs}h ago`
}

export default function LiveStatsStrip({ fallback = {} }) {
  const [stats, setStats] = useState(fallback)
  const [now, setNow] = useState(null)
  const { formatDealPrice } = useCurrency()

  useEffect(() => {
    fetch('/api/live-stats')
      .then(r => r.json())
      .then(setStats)
      .catch(() => {})
    setNow(Date.now())
    const id = setInterval(() => setNow(Date.now()), 60000)
    return () => clearInterval(id)
  }, [])

  const lastScan = now && stats.lastFetchedAt ? timeAgo(stats.lastFetchedAt) : null

  const bestSaving = stats.bestSavingEur != null
    ? formatDealPrice(stats.bestSavingEur).primary
    : '—'

  const STATIC = [
    { label: 'Best deal today',  icon: '✂️', value: stats.bestDiscount  != null ? `−${stats.bestDiscount}%` : '—' },
    { label: 'Best deal today',    icon: '💶', value: bestSaving },
    { label: 'Routes with deals', icon: '⚡', value: stats.totalDeals    != null ? String(stats.totalDeals) : '—' },
    { label: 'Commission, always',   icon: '💰', value: '0%' },
  ]

  return (
    <div className="grid grid-cols-2 sm:grid-cols-5 gap-4 text-center">
      {STATIC.map(({ label, icon, value }) => (
        <div key={label} className="flex flex-col items-center">
          <div className="text-2xl mb-1">{icon}</div>
          <div className="text-2xl font-extrabold text-gray-900">{value}</div>
          <div className="text-xs text-gray-500 mt-0.5 leading-tight">{label}</div>
        </div>
      ))}
      <div className="flex flex-col items-center">
        <div className="text-2xl mb-1">🕐</div>
        <div className="text-2xl font-extrabold text-gray-900">{lastScan ?? '—'}</div>
        <div className="text-xs text-gray-500 mt-0.5 leading-tight">Last deal found</div>
      </div>
    </div>
  )
}
